module.exports = () => {
    return new Promise((resolve) => {
        require.ensure([], () => {
            resolve({
                Login: require('@js/components/users/login').default,
                Signup: require('@js/components/users/signup').default
            });
        }, 'user-connection');
    });
};
